import { Component, Inject, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EmailDialogType } from "src/app/constants/email-dialog-type";
import { EmailDocumentDialogModel } from "src/app/models/dialog";
import { FormValidationService } from "src/app/services/form-validation.service";

@Component({
    selector: 'mwp-dialog-document',
    templateUrl: './email-document.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogEmailDocumentComponent implements OnInit {
    public inputForm: FormGroup;

    public title: string;
    public documentType: string;
    public warningText: string;
    public buttonText: string;

    public titleJsonKey: string;
    public documentTypeJsonKey: string;
    public warningTextJsonKey: string;
    public buttonTextJsonKey: string;

    constructor(
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<DialogEmailDocumentComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: EmailDialogType,
    ) {
    }

    ngOnInit(): void {
        const jsonPrefix: string = "documentEmailDialog";
        switch (this.dialogData) {
            case EmailDialogType.benefitSummary:
                this.title = "Email Benefit Summary";
                this.titleJsonKey = `${jsonPrefix}benefitSummaryTitle`;
                this.documentType = "Benefit Summary Statement";
                this.documentTypeJsonKey = `${jsonPrefix}benefitSummaryDocumentType`;
                this.warningText = `Your ${this.documentType} statement contains personal, non-public information pertaining to your benefits. Please only enter an email address that you either own, or completely trust the recipient who will receive this email with your personal benefits information attached. Once this email is sent, it cannot be recalled, and can only be deleted by the recipient. Please double check the spelling of the email address before confirming`;
                this.warningTextJsonKey = `${jsonPrefix}benefitSummaryWarningText`;
                this.buttonText = `Email ${this.documentType}`;
                this.buttonTextJsonKey = `${jsonPrefix}benefitSummaryButtonText`;
                break;
            case EmailDialogType.payStub:
                this.title = 'Email Pay Stub';
                this.titleJsonKey = `${jsonPrefix}payStubTitle`;
                this.documentType = 'Pay Stub';
                this.documentTypeJsonKey = `${jsonPrefix}payStubDocumentType`;
                this.warningText = `Your ${this.documentType} contains personal, non - public information pertaining to your pay. Please only enter an email address that you either own, or completely trust the recipient who will receive this email with your personal pay information attached. Once this email is sent, it cannot be recalled, and can only be deleted by the recipient. Please double check the spelling of the email address before confirming.`;
                this.warningTextJsonKey = `${jsonPrefix}payStubWarningText`;
                this.buttonText = `Email ${this.documentType}`;
                this.buttonTextJsonKey = `${jsonPrefix}payStubButtonText`;
                break;
            case EmailDialogType.annualStatement:
                this.title = 'Email Annual Statement';
                this.titleJsonKey = `${jsonPrefix}annualStatementTitle`;
                this.documentType = 'Annual Statement';
                this.documentTypeJsonKey = `${jsonPrefix}annualStatementDocumentType`;
                this.warningText = `Your ${this.documentType} contains personal, non - public information pertaining to your pay. Please only enter an email address that you either own, or completely trust the recipient who will receive this email with your personal pay information attached. Once this email is sent, it cannot be recalled, and can only be deleted by the recipient. Please double check the spelling of the email address before confirming.`;
                this.warningTextJsonKey = `${jsonPrefix}annualStatementWarningText`;
                this.buttonText = `Email ${this.documentType}`;
                this.buttonTextJsonKey = `${jsonPrefix}annualStatementButtonText`;
                break;
            case EmailDialogType.form1095:
                this.title = 'Email Form 1095';
                this.titleJsonKey = `${jsonPrefix}form1095Title`;
                this.documentType = 'Form 1095';
                this.documentTypeJsonKey = `${jsonPrefix}form1095DocumentType`;
                this.warningText = `Your ${this.documentType} contains personal, non - public information pertaining to your pay. Please only enter an email address that you either own, or completely trust the recipient who will receive this email with your personal pay information attached. Once this email is sent, it cannot be recalled, and can only be deleted by the recipient. Please double check the spelling of the email address before confirming.`;
                this.warningTextJsonKey = `${jsonPrefix}form1095WarningText`;
                this.buttonText = `Email ${this.documentType}`;
                this.buttonTextJsonKey = `${jsonPrefix}form1095ButtonText`;
                break;
            case EmailDialogType.w2:
                this.title = 'Email W2';
                this.titleJsonKey = `${jsonPrefix}w2Title`;
                this.documentType = 'W2';
                this.documentTypeJsonKey = `${jsonPrefix}w2DocumentType`;
                this.warningText = `Your ${this.documentType} contains personal, non - public information pertaining to your pay. Please only enter an email address that you either own, or completely trust the recipient who will receive this email with your personal pay information attached. Once this email is sent, it cannot be recalled, and can only be deleted by the recipient. Please double check the spelling of the email address before confirming.`;
                this.warningTextJsonKey = `${jsonPrefix}w2WarningText`;
                this.buttonText = `Email ${this.documentType}`;
                this.buttonTextJsonKey = `${jsonPrefix}w2ButtonText`;
                break;
            default:
                this.title = '';
                this.titleJsonKey = '';
                this.documentType = '';
                this.documentTypeJsonKey = '';
                this.warningText = '';
                this.warningTextJsonKey = '';
                this.buttonText = '';
                this.buttonTextJsonKey = '';
                break;
        }
        this.inputForm = this.formBuilder.group({
            ['emailInput']: [null, [Validators.required, Validators.compose([FormValidationService.validEmail(true)])]]
        });
    }

    public buttonClicked(): void {
        const emailDocumentDialogModel: EmailDocumentDialogModel = new EmailDocumentDialogModel();
        emailDocumentDialogModel.email = this.inputForm.get('emailInput').value;
        this.dialogRef.close(emailDocumentDialogModel);
    }



    public close(): void {
        this.dialogRef.close();
    }
}